import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

function EbayDescBtn() {
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!file) return alert('Please select a file');

    const formData = new FormData();
    formData.append('file', file);

    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/products/ebay-descriptions/generate`,
        {
          method: 'POST',
          credentials: 'include',
          body: formData,
        }
      );

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || 'Failed to generate descriptions');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'ebay_descriptions.zip';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setShowModal(false);
      setFile(null);
    } catch (err) {
      console.error(err);
      alert(err.message || 'Error generating eBay descriptions');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className='btn btn-primary btn-sm me-4' onClick={() => setShowModal(true)}>
        eBay Descriptions
      </button>

      <Modal show={showModal} onHide={() => { if (!loading) { setShowModal(false); setFile(null); } }}>
        <Modal.Header closeButton>
          <Modal.Title>Generate eBay Descriptions</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group controlId="formFile">
              <Form.Label>Select Product Descriptions Excel File (.xlsx)</Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx"
                onChange={handleFileChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => { setShowModal(false); setFile(null); }} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading || !file}
          >
            {loading ? 'Generating...' : 'Generate'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EbayDescBtn;
